import type { TypeOpsActivity, TypeOpsActivityQuery } from '@/types/ops/types.ops.activity';

const listed = (csv: string, value: string): boolean => !csv || csv.split(',').includes(value);

export function opsActivityMatches(item: TypeOpsActivity, query: TypeOpsActivityQuery): boolean {
    if (query.server && item.server !== query.server) return false;
    if (!listed(query.kind, item.kind)) return false;
    if (!listed(query.result, item.result)) return false;
    if (query.actor && !item.actor.toLowerCase().includes(query.actor.toLowerCase())) return false;

    const at = Date.parse(item.ts);
    if (!Number.isFinite(at)) return false;
    if (query.from && at < Date.parse(query.from)) return false;
    if (query.to && at >= Date.parse(query.to)) return false;
    return true;
}

export default opsActivityMatches;
